module.exports = __webpack_public_path__ + "media/images/icons/checkmark-9aad8d530f792cba934d3eeb57f6ab00.svg";